import React, { useEffect, useRef, useState } from "react";
import "../../styles/styles.css";
import "../../styles/layout.css";
import { AddCircleOutline } from "@mui/icons-material";
import { Button } from "@mui/material";
import LeaveBalanceChart from "./LeaveBalance_Chart";
import LeaveBalanceList from "./LeaveBalance_List";
import AddLeaveBalanceFormModal from "./AddLeaveBalance";
import { getUserInfoFromToken } from "../../utils/authUtils";


const LeaveBalance = () => {
  // const userType = localStorage.getItem("user_type");
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
    
  const [showModal, setShowModal] = useState(false);
  const [editLeaveBalance, setEditLeaveBalance] = useState(null);

  const openModalForCreate = () => {
    setEditLeaveBalance(null);
    setShowModal(true);
  };

  const openModalForEdit = (company) => {
    setEditLeaveBalance(company);
    setShowModal(true);
  };
  const formikRef = useRef();
                    useEffect(() => {
                    const { userType, userId } = getUserInfoFromToken();
                    setUserType(userType);
                    setUserId(userId);
                  }, []);

  if (userType === "Employee") {
    return <LeaveBalanceChart />;
  } else if (userType === "Employer") {
    return (
      <div>
        {/* Conditional Rendering for Manage Leave Button or Leave Year */}
        <div className="d-flex justify-content-end mb-3">
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddCircleOutline />}
            onClick={openModalForCreate}
          >
            Manage Leave Balance
          </Button>
        </div>

        <AddLeaveBalanceFormModal 
         show={showModal}
         handleClose={() => setShowModal(false)}
         initialData={editLeaveBalance}
        />
        <LeaveBalanceList />
      </div>
    );
  } else {
    return <div>User type not recognized. Please log in again.</div>;
  }
};

export default LeaveBalance;
